import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import CustomHeader from './CustomHeader';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import { createFile } from 'services/fileManager/fileManagerServices';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import TextSnippetWrapper from 'components/TextSnippetWrapper';

function CreateFolderModal() {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const {
    modals,
    fileManagerFilters,
    isCaseFileManager,
    isLeadFileManager,
    isFirmDocuments,
    caseDetails,
    handleGetFiles,
    pageLimit,
    breadCrumbs,
  } = useFileManagerContext();
  const { showCreateFolderModal, setShowCreateFolderModal } = modals;
  const { addToast } = useToast();

  function createFolder(data) {
    let breadCrumbsLength = breadCrumbs?.length;

    // Always set case_id to undefined for firm documents
    if (isFirmDocuments) {
      data.case_id = undefined;
    } else {
      data.case_id = caseDetails?.case_id;
    }
    data.type = 'folder';
    // data.folder_id = fileManagerFilters.selectedFolder || '';
    data.folder_id = breadCrumbs[breadCrumbsLength - 1]?.value || '';
    data.display_name = data.folderName;
    data.is_lead = isLeadFileManager;

    // Ensure case_id is always included in the payload, even when undefined
    if (isFirmDocuments) {
      data.case_id = undefined;
    }

    // Create the data object with explicit case_id field
    const payloadData = {
      folderName: data.folderName,
      type: data.type,
      folder_id: data.folder_id,
      display_name: data.display_name,
    };

    // Always include case_id field - set to undefined for firm documents
    if (isFirmDocuments) {
      payloadData.case_id = undefined;
    } else {
      payloadData.case_id = data.case_id;
    }

    // Force include undefined case_id in JSON by using custom stringify
    const finalPayload = {
      folderName: payloadData.folderName,
      type: payloadData.type,
      folder_id: payloadData.folder_id,
      display_name: payloadData.display_name,
      case_id: isFirmDocuments ? undefined : payloadData.case_id,
    };

    // Custom JSON stringify that preserves undefined values
    const jsonString = JSON.stringify(finalPayload, (key, value) => {
      if (value === undefined) {
        return 'undefined';
      }
      return value;
    });

    // Parse back to get the object with 'undefined' strings
    const payloadWithUndefined = JSON.parse(jsonString);

    let obj = {
      data: payloadWithUndefined,
      is_lead: isLeadFileManager,
      isFirmDocuments: isFirmDocuments,
    };

    // Debug log to verify the payload

    createFile(obj)
      .then((response) => {
        handleGetFiles(pageLimit, breadCrumbs[breadCrumbsLength - 1]?.value);

        setShowCreateFolderModal(false);
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.FOLDER_CREATED);
      })
      .catch((error) => {
        console.log('Folder creation failed:', error);
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.ERROR, toastConstant.message.FOLDER_CREATE_FAILED);
      });
  }

  const footer = (
    <div className="footer-btn">
      <Button label="Cancel" onClick={() => setShowCreateFolderModal(false)} className="p-button p-button-secondary outline" />
      <Button label="Create" onClick={handleSubmit(createFolder)} className="p-button p-button-secondary me-0" />
    </div>
  );

  return (
    <Dialog
      className="rounded-radius FM-popup new-task-popup"
      header={<CustomHeader title="" onHide={() => setShowCreateFolderModal(false)} />}
      footer={footer}
      visible={showCreateFolderModal}
      style={{ width: '40vw' }}
      modal
      onHide={() => setShowCreateFolderModal(false)}
      closable={false}
    >
      <div className="modal-heading F-size16 text-bold mb-4">Create Folder</div>
      <Controller
        name="folderName"
        control={control}
        defaultValue={''}
        rules={{ required: true }}
        render={({ field }) => (
          <TextSnippetWrapper
            type="text"
            {...field}
            onChange={(e) => {
              field.onChange(e);
            }}
            placeholder="Folder Name"
            className="input-shadow w-100 mt-2"
          />
        )}
      />
      {errors?.folderName && <InputErrorMessage>Required</InputErrorMessage>}
    </Dialog>
  );
}

export default CreateFolderModal;
